module.exports = __webpack_public_path__ + "static/media/SBIN_F1.7488707d.txt";